<template>
    <div class="animated fadeIn">
        <div v-if="!addMode && !editMode" class="viewMode">
            <b-row>
                <b-col cols="12">
                    <h1>Documents</h1>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-card>
                        <div slot="header">
                            <strong>Documents</strong>
                        </div>
                        <div v-if="!documentsLoaded" class="form-container">
                            <LoadingSpinner />
                        </div>
                        <div v-if="documentsLoaded" class="form-container">
                            <b-row v-if="isSuperAdministrator">
                                <b-col cols="12" sm="12" md="6">
                                    <p>
                                        <b-button v-on:click="enterAddMode" variant="primary">
                                            <i class="fa fa-plus"></i>&nbsp;Add Document
                                        </b-button>
                                    </p>
                                </b-col>
                            </b-row>
                            <p v-if="documents.length == 0">There are no Documents to display.</p>
                            <b-row>
                                <b-col sm="12" md="4" v-for="(document, index) in documents" v-bind:key="index">
                                    <b-card>
                                        <a :href="document.document_link" target="_blank">{{document.title}}</a>
                                        <p>{{document.description}}</p>
                                        <b-button v-if="isSuperAdministrator" @click="enterEditMode(document)" variant="primary"><i class="fa fa-pencil"></i>&nbsp;Edit</b-button>
                                        <b-button class="ml-2" v-if="isSuperAdministrator" @click="deleteDocument(document)" variant="danger"><i class="fa fa-trash"></i>&nbsp;Delete</b-button>
                                    </b-card>
                                </b-col>
                            </b-row>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </div>
        <div v-if="addMode && !editMode" class="addMode">
            <b-row>
                <b-col cols="12">
                    <h1>Documents</h1>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-card>
                        <div slot="header">
                            <strong>Add New Document</strong>
                        </div>
                        <b-button v-on:click="exitAddMode" variant="secondary">
                            <i class="fa fa-arrow-circle-left"></i>&nbsp;Back
                        </b-button>
                        <div class="form-container">
                            <br/>
                            <b-row>
                                <b-col sm="6">
                                    <b-form-group>
                                        <label for="title">Title</label>
                                        <b-form-input
                                            v-model="newDocument.title"
                                            type="text"
                                            id="title"
                                            :disabled=false
                                        ></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="6">
                                    <b-form-group>
                                        <label for="document">Upload Document</label>
                                        <br/>
                                        <input type="file"
                                            :name="newDocument.document"
                                            @change="filesChange($event.target.name, $event.target.files)"
                                            @size-exceeded="onDocumentSizeExceeded"
                                            fileCount ="$event.target.files.length"
                                            accept="pdf/*" class="input-file">
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="6">
                                    <b-form-group>
                                        <label for="desc">Description</label>
                                        <b-form-textarea
                                            id="desc"
                                            v-model="newDocument.description"
                                            rows="3"
                                            max-rows="6"
                                            :disabled=false
                                        ></b-form-textarea>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <hr />
                            <b-row>
                                <b-col cols="12" sm="12" md="12">
                                    <p>
                                        <b-button v-on:click="saveDocument" variant="primary" :disabled="!allowSave">
                                            <i class="fa fa-check"></i>&nbsp;Save Document
                                        </b-button>
                                    </p>
                                    <b-alert v-if="saveError" variant="danger" show><strong>Error saving data. Please try again.</strong></b-alert>
                                    <b-alert v-if="saveSuccess" variant="success" show><strong>Data saved successfully.</strong></b-alert>
                                    <b-alert v-if="saveInProgress" variant="info" show><strong>Saving data. Please wait...</strong></b-alert>
                                </b-col>
                            </b-row>
                        </div>
                    </b-card>
                </b-col>
             </b-row>
        </div>
        <div v-if="!addMode && editMode" class="editMode">
            <b-row>
                <b-col cols="12">
                    <h1>Documents</h1>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-card>
                        <div slot="header">
                            <strong>Update Document</strong>
                        </div>
                        <b-button v-on:click="exitEditMode" variant="secondary">
                            <i class="fa fa-arrow-circle-left"></i>&nbsp;Back
                        </b-button>
                        <div class="form-container">
                            <br/>
                            <b-row>
                                <b-col sm="6">
                                    <b-form-group>
                                        <label for="title">Title</label>
                                        <b-form-input
                                            v-model="editDocument.title"
                                            type="text"
                                            id="title"
                                            :disabled=false
                                        ></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="6">
                                    <b-form-group>
                                        <label for="document">Upload Document</label>
                                        <br/>
                                        <input type="file"
                                            :name="editDocument.document"
                                            @change="filesChangeEdit($event.target.name, $event.target.files)"
                                            @size-exceeded="onDocumentSizeExceeded"
                                            fileCount ="$event.target.files.length"
                                            accept="pdf/*" class="input-file">
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="6">
                                    <b-form-group>
                                        <label for="desc">Description</label>
                                        <b-form-textarea
                                            id="desc"
                                            v-model="editDocument.description"
                                            rows="3"
                                            max-rows="6"
                                            :disabled=false
                                        ></b-form-textarea>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <hr />
                            <b-row>
                                <b-col cols="12" sm="12" md="12">
                                    <p>
                                        <b-button v-on:click="updateDocument" variant="primary" :disabled="!allowUpdate">
                                            <i class="fa fa-check"></i>&nbsp;Update Document
                                        </b-button>
                                    </p>
                                    <b-alert v-if="saveError" variant="danger" show><strong>Error saving data. Please try again.</strong></b-alert>
                                    <b-alert v-if="saveSuccess" variant="success" show><strong>Data saved successfully.</strong></b-alert>
                                    <b-alert v-if="saveInProgress" variant="info" show><strong>Saving data. Please wait...</strong></b-alert>
                                </b-col>
                            </b-row>
                        </div>
                    </b-card>
                </b-col>
             </b-row>
        </div>
    </div>
</template>

<script>

import LoadingSpinner from '../../components/loadingSpinner/LoadingSpinner';
import { Switch as cSwitch } from '@coreui/vue';
import cTable from '../../components/table/Table';

const getHTTPHeaders = () => {
    let userObj = JSON.parse(localStorage.getItem('user'));
    let headerConfig = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': 'Bearer ' + userObj.token,
        }
    }
    return headerConfig;
}

const getDocumentList = (($http) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
        $http.get("documents", headersObj)
            .then((response) => {
                resolve(response.data.documents);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});

export default {
    name: 'documents',
    components: {
        LoadingSpinner: LoadingSpinner,
        cSwitch,
        cTable
    },
    data () {
        return {
            addMode: false,
            editMode: false,
            saveSuccess: false,
            saveError: false,
            saveInProgress: false,
            userObj: {},
            documentsLoaded: true,
            documents: [],
            newDocument: {
                document: "",
                title: "",
                description: ""
            },  
            editDocument: {
                id: 0,
                document: "",
                title: "",
                description: ""
            },
            userAuthLevel : '',
            userInputMode: 'add',
            document: null
        }
    },
    created () {
        this.getCurrentUser()
            .then((userObj) => {
                this.$data.userAuthLevel = userObj.auth;
                this.getDocuments(); 
            })
    },
    computed: {
        isUserReadOnly() {
            return (this.$data.userAuthLevel === 'Read Only');
        },
        isSuperAdministrator() {
            return (this.$data.userAuthLevel === 'Super Admin');
        },
        allowSave() {
            return this.$data.newDocument.title != "" && this.$data.newDocument.document && this.$data.newDocument.description != "" ? true : false;
        },
        allowUpdate() {
          console.log(this.$data.editDocument);
            return this.$data.editDocument.title != "" && this.$data.editDocument.description != "" ? true : false;
        }
    },
    methods : {
        getCurrentUser () {
            return new Promise((resolve, reject) => {
                let user = JSON.parse(localStorage.getItem('user'));
                if (user != null) {
                    resolve(user);
                }
                else {
                    reject();
                }
            });
        },
        getDocuments() {
            getDocumentList(this.$http)
                .then((response) => {
                    this.$data.documents = response;
                    this.$data.documentsLoaded = true;
                })
                .catch ((err) => {
                    console.error(err);
                });
        },
        exitAddMode() {
            this.$data.addMode = false;
            this.getDocuments();        
        },
        exitEditMode() {
            this.$data.editMode = false;
            this.getDocuments();
        },
        enterAddMode() {
            this.$data.addMode = true;
            this.$data.allowSave = false;
            this.$data.newDocument.document = "";
            this.$data.newDocument.title = "";
            this.$data.newDocument.description = "";
            console.log(this.$data.newDocument);
        },
        enterEditMode(link) {
            this.$data.editMode = true;
            this.$data.allowSave = false;
            this.$data.editDocument.id = link.id;
            this.$data.editDocument.document = link.document;
            this.$data.editDocument.title = link.title;
            this.$data.editDocument.description = link.description;
            console.log(this.$data.editDocument);
        },
        clearAlerts() {
            this.$data.saveError = false;
            this.$data.saveInProgress = false;
        },
        getHTTPHeaders() {
            let userObj = JSON.parse(localStorage.getItem('user'));
            let headerConfig = {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': 'Bearer ' + userObj.token,
                }
            }
            return headerConfig;
        },
        saveDocument() {
            this.clearAlerts();
            this.$data.saveInProgress = true;
            let headersObj = this.getHTTPHeaders();

            const formData = new FormData();
            let payload = {
                title: this.$data.newDocument.title,
                document: this.$data.newDocument.document,
                description: this.$data.newDocument.description,
            }

            for (let key in payload) {
                formData.append(key, payload[key])
            }

            this.$http.post('document', formData, headersObj)
            .then((response) => {
                console.log(response.data);
                if (response.data.success == true) {
                    this.$data.saveInProgress = false;
                    this.$data.saveError = false;
                    this.$data.saveSuccess = true;
                    this.exitAddMode();
                }
                else {
                    // data error
                    this.$data.saveInProgress = false;
                    this.$data.saveError = true;
                    this.$data.saveSuccess = false;
                }
            })
            .catch ((err) => {
                console.error(err);
                this.$data.saveInProgress = false;
                this.$data.saveSuccess = false;
                this.$data.saveError = false;
            });
        },
        updateDocument() {
            this.clearAlerts();
            this.$data.saveInProgress = true;
            let headersObj = this.getHTTPHeaders();

            const formData = new FormData();
            let payload = {
                title: this.$data.editDocument.title,
                document: this.$data.editDocument.document,
                description: this.$data.editDocument.description,
                document_link: this.$data.editDocument.document_link
            }

            for (let key in payload) {
                formData.append(key, payload[key])
            }

            formData.append('_method', 'PUT');

            this.$http.post('document/'+this.$data.editDocument.id, formData, headersObj)
            .then((response) => {
                console.log(response.data);
                if (response.data.success == true) {
                    this.$data.saveInProgress = false;
                    this.$data.saveError = false;
                    this.$data.saveSuccess = true;
                    this.exitEditMode();
                }
                else {
                    // data error
                    this.$data.saveInProgress = false;
                    this.$data.saveError = true;
                    this.$data.saveSuccess = false;
                }
            })
            .catch ((err) => {
                console.error(err);
                this.$data.saveInProgress = false;
                this.$data.saveSuccess = false;
                this.$data.saveError = false;
            });
        },
        deleteDocument(document) {
            let headersObj = this.getHTTPHeaders();

            //document.deleted = 1;

            this.$http.delete('document/'+document.id, headersObj)
            .then((response) => {
                console.log(response.data);
                if (response.data.success == true) {
                    this.getDocuments();
                }
            })
            .catch ((err) => {
                console.error(err);
            });
        },
        onDocumentSizeExceeded() {
            console.log('on logo exceed');
        },
        filesChange(fieldName, fileList) {
            if (!fileList.length) return;
            this.newDocument.document = fileList[0]
        },
        filesChangeEdit(fieldName, fileList) {
            if (!fileList.length) return;
            this.editDocument.document = fileList[0]
        },
    }
}
</script>
